import { render, staticRenderFns } from "./UserSelector.vue?vue&type=template&id=053d68ce&scoped=true&"
import script from "./UserSelector.vue?vue&type=script&lang=js&"
export * from "./UserSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053d68ce",
  null
  
)

export default component.exports